// extracted by mini-css-extract-plugin
module.exports = {"component":"AlbumGrid_component__C8P2W","row":"AlbumGrid_row__qRmJd","album":"AlbumGrid_album__3UBTP","cover":"AlbumGrid_cover__3r9Yx","albumInfo":"AlbumGrid_albumInfo__M6_n9"};